module.exports = __webpack_public_path__ + "static/media/normal.3ea202ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/normal.png
// module id = 52
// module chunks = 0